import { ru } from "vuetify/lib/locale";
import "vuetify/styles";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";
import { VCalendar } from "vuetify/lib/labs/VCalendar";
import { VDateInput } from 'vuetify/labs/VDateInput'

import "vuetify/styles";
import { createVuetify } from "vuetify/dist/vuetify";
import "@mdi/font/css/materialdesignicons.css";

export const themes = {
  options: {
    customProperties: true,
  },
  defaultTheme: "main",
  themes: {
    main: {
      dark: false,
      colors: {
        surface: "#003A72",
        "surface-variant": "#185EAA",
        primary: "#003A72",
        attention: "#FF6400",
        secondary: "#185EAA",
        accent: "#FFFFFF",
        error: "#720013",
        info: "#275EBC",
        success: "#02a202",
        editing: "#157f19",
        warning: "#e08900",
        tooltip: "#C0231F",
        "white-blue": "#FAFCFF",
      },
    },
  },
};

export const VuetifyPlugin = createVuetify({
  icons: {
    defaultSet: "mdi",
  },
  theme: themes,
  locale: {
    locale: "ru",
    fallback: "ru",
    messages: { ru },
  },
  components: {
    ...components,
    VCalendar,
    VDateInput,
  },
  directives,
});
